const { create } = require('zustand');

export const useProvidersStore = create((set) => ({
  providerData: null,
  setProviderData: (provider) => set(() => ({ providerData: provider })),
  deleteProviderData: () => set(() => ({ providerData: null })),
}));
